export default function getModules() {
  return {
    useLimitedAds: true,
    useLoadPrebidBeforeConsent: true,
    useGLazyLoad: ['ad-topbanner1', 'ad-top-mobile1', 'ad-sticky-right-top1', 'ad-sticky-left-top1', 'ad-fullscreen1', 'ad-sticky-bottom1'],
    useStats: true,
    useCustomNO: true,
  };
}

export const getNOPathIdExceptions: PathIdExceptions = {
  'sol.no': 'sol',
};
